import React, { useReducer, useEffect } from 'react';
import postal from 'postal';
import styles from './styles/styles.module.scss';
import ClientSideRouting from '../../shared/ClientSideRouting';
import { Page } from '../../shared/Page/Page';
import GiftFlowRouting from '../GiftFlowRouting';

const GiftFlowContext = React.createContext({});

const initialState = {
  activePlanType: 0,
  giftCustomizeParams: {
    backgroundId: 'gc-1',
    sendMethod: 'email',
    sendDate: new Date(),
    recipientName: '',
    recipientEmail: '',
    message: '',
    senderName: '',
    senderEmail: ''
  },
  serverErrors: [],
  purchasedGiftCard: null
};

// actions
const TOGGLE_PLAN_TYPE = 'TOGGLE_PLAN_TYPE';
const UPDATE_GIFT_CUSTOMIZE_FORM = 'UPDATE_GIFT_CUSTOMIZE_FORM';
const UPDATE_SERVER_ERRORS = 'UPDATE_SERVER_ERRORS';
const UPDATE_PURCHASED_GIFT_CARD = 'UPDATE_PURCHASED_GIFT_CARD';
const RESTART_GIFT_FLOW = 'RESTART_GIFT_FLOW';

const giftFlowReducer = (state, action) => {
  switch (action.type) {
    case TOGGLE_PLAN_TYPE: {
      return { ...state, activePlanType: action.payload };
    }
    case UPDATE_GIFT_CUSTOMIZE_FORM: {
      return { ...state, giftCustomizeParams: action.payload };
    }
    case UPDATE_SERVER_ERRORS: {
      return { ...state, serverErrors: action.payload };
    }
    case UPDATE_PURCHASED_GIFT_CARD:
      return { ...state, purchasedGiftCard: action.payload };
    case RESTART_GIFT_FLOW:
      return initialState;
    default:
      return state;
  }
};

const navigationMessagingChannel = postal.channel('navigation_messagingChannel');

const GiftFlow = ({
  currencyCode,
  facebookAppId,
  googleClientId,
  amazonClientId,
  amazonSellerId,
  paymentTypes,
  giftSubscription,
  shopifyToken,
  shopifyCollectionId,
  enableRecaptcha,
  planTypes,
  recurlyPublicKey,
  requestPath,
  context
}) => {
  const [giftFlowState, dispatchGiftFlow] = useReducer(giftFlowReducer, {
    ...initialState,
    purchasedGiftCard: giftSubscription
  });

  return (
    <Page context={context}>
      <div className={styles.container}>
        <GiftFlowContext.Provider value={{ giftFlowState, dispatchGiftFlow }}>
          <ClientSideRouting path={requestPath}>
            <GiftFlowRouting
              facebookAppId={facebookAppId}
              googleClientId={googleClientId}
              planTypes={planTypes}
              currencyCode={currencyCode}
              paymentTypes={paymentTypes}
              recurlyPublicKey={recurlyPublicKey}
              amazonClientId={amazonClientId}
              amazonSellerId={amazonSellerId}
              navigationMessagingChannel={navigationMessagingChannel}
              enableRecaptcha={enableRecaptcha}
              shopifyToken={shopifyToken}
              shopifyCollectionId={shopifyCollectionId}
            />
          </ClientSideRouting>
        </GiftFlowContext.Provider>
      </div>
    </Page>
  );
};

// TODO:  propTypes coming once we get more of the flow

export {
  GiftFlow,
  GiftFlowContext,
  TOGGLE_PLAN_TYPE,
  UPDATE_GIFT_CUSTOMIZE_FORM,
  UPDATE_SERVER_ERRORS,
  UPDATE_PURCHASED_GIFT_CARD,
  RESTART_GIFT_FLOW
};
